module.exports = __webpack_public_path__ + "mu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/mu.svg
// module id = 710
// module chunks = 0